/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoIcon16Light = forwardRef('TechCamVideoIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 3A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13h6a2.5 2.5 0 0 0 2.5-2.5v-.328l2.429 1.691a1 1 0 0 0 1.571-.82V4.957a1 1 0 0 0-1.571-.82L12 5.827V5.5A2.5 2.5 0 0 0 9.5 3h-6ZM12 7.046v1.908l3 2.089V4.957l-3 2.089ZM2 5.5A1.5 1.5 0 0 1 3.5 4h6A1.5 1.5 0 0 1 11 5.5v5A1.5 1.5 0 0 1 9.5 12h-6A1.5 1.5 0 0 1 2 10.5v-5Z" })));
});
